import base from '../dr-base'
import drSpacer from './dr-spacer.vue'

const schema = {
  ...base,
  $Type: 'dr-spacer',
  icon: 'arrows-h',
  name: 'Spacer',
  group: 'Container widgets',
  properties: {
    ...base.properties
  }
}

export default {
  schema,
  component: drSpacer
}
